@import "../../../styles/globals";

flutscher {
  display: block;
  position: relative;
  width: 100%;
  overflow: hidden;
  background-color: white;
  padding-top: 60px;
  padding-bottom: 60px;
  padding-left: 0;
  padding-right: 0;

  .slide { transition: transform 430ms ease; }

  &.from-right {
    .slide {
      transform: translateX(110vw);
    }

    &.sneak-in {
      .slide {
        transform: translateX(0vw);
      }
    }

    .background {
      left: 0;
      .ext { left: 50%; }
    }
  }

  &.from-left {
    .slide {
      transform: translateX(-110vw);
    }

    &.sneak-in {
      .slide {
        transform: translateX(0vw);
      }
    }

    .background {
      right: 0;
      .ext {
        right: 50%;
      }
    }
  }

  .container {
    position: relative;
    padding: 0.1em;
    .container_inner_narrow{
      position: relative;
    }
  }

  .background {
    position: absolute;
    top: 0;
    bottom: 0;
    z-index: 0;
    img {
      border-radius: 50%;
      height: 100%;
      width: auto;
      background-color: $yellow;
    }
    .ext {
      position: absolute;
      top: 0;
      bottom: 0;
      background-color: $yellow;
      width: 2000px;
      z-index: 0;
    }
  }

  .bkgrnd-top{
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 50%;
  }

  .bkgrnd-bottom {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    top: 50%;
  }

  &.background-split-normal {
    .bkgrnd-top {background-color: $cream}
  }

  &.background-split-reverse {
    .bkgrnd-bottom {background-color: $cream}
  }

}
